import React from "react";
import "./index.css";
import cn from "classnames";
import BgTransformer from "layout/BgTransformer";
import PixelationLayer from "layout/PixelationLayer";
import Textarea from "layout/Textarea/Textarea";
import ContentEditable from "../../../layout/ContentEditable/ContentEditable";
import {useSetting} from "contexts/setting";
import {useEdits} from "contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";
import {checkIfIDE} from "data/products/index";
import {checkProductInText} from "libs/utils";
import {PLACEHOLDERS} from "data/constants";
import {resolveProductAccentColor} from "utils/colors";
import {useLogoUrl} from "../../../hooks/useLogoUrl";
import {HIDING_NAME_SET} from "data/products/index";
import {palettes} from "data/palettes";
import AirBanner, {isAirBanner} from "pages/Releases/AirBanner";

const WhatsNewPreview = ({id, zoom}) => {
  const {product, layoutOption, channel} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {titles, features, productNames} = useEdits();
  const defaultProductName = product.shortLabel || product.label;
  const productName = productNames[id] || productNames.main || defaultProductName;
  const logoSrc = useLogoUrl(id);
  const logoClass = cn("logo", {ide: checkIfIDE(product.value)});

  const title = titles[id] ?? titles.main ?? PLACEHOLDERS.en.title;
  const featureText = features[id] ?? features.main ?? PLACEHOLDERS.en.features;
  const accentColor = resolveProductAccentColor(product.value, palettes);
  const showProductName =
    !HIDING_NAME_SET.has(product.value) &&
    !checkProductInText(productName, title) &&
    !checkProductInText(product.label, title);

  // JetBrains Air replaces the whole banner rather than restyling this one:
  // every channel that lists the product draws the same skin (src/data/offering.ts).
  if (isAirBanner(product.value)) {
    return <AirBanner id={id} zoom={zoom} copy="features" />;
  }

  return (
    <div
      id={id}
      className={cn("template", product.value, "whats-new-preview", `layout-${layoutOption}`)}
      style={{"--zoom-level": zoom}}
    >
      <div>
        <BgTransformer src={bgUrl} id={id} />
        <PixelationLayer />
        <div className="content">
          <header className="template-header">
            <div className={logoClass}>
              <img src={logoSrc} alt="logo" />
            </div>
            {showProductName && (
              <div className="product-name">
                <ContentEditable id={id} text={productName} />
              </div>
            )}
          </header>

          <div className="copy-wrap">
            <div className="title-wrap">
              <h1 className="title">
                <Textarea id={id} text={title} />
              </h1>
            </div>

            <div className="features">
              <ContentEditable
                id={id}
                text={featureText}
                isList={true}
                enableBoldHotkey={true}
                enableBoldAccentHotkey={true}
                boldAccentColor={accentColor}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsNewPreview;
